<template>
  <b-row>
    <b-col cols="12">
      <b-card class="bg-gray" border-variant="none">
        <b-row v-if="item">
          <b-col cols="12" :md="!readonly && !editting ? 11 : 12">
            <b-row>
              <b-col cols="12" md class="mt-2 mt-md-0">
                <div class="color-secondary-6 font-14">
                  Categoría de Alternativa:
                </div>
                <div class="color-black font-16">
                  {{
                    item.category &&
                      ((item.id ? item.id + ' - ' : '') + item.category.name)
                        | empty
                  }}
                </div>
              </b-col>
              <b-col cols="12" md class="mt-2 mt-md-0">
                <div class="color-secondary-6 font-14">
                  Nombre de Alternativa:
                </div>
                <div class="color-black font-16">
                  {{ item.name?.name | empty }}
                </div>
              </b-col>
              <b-col cols="12" md class="mt-2 mt-md-0">
                <div class="color-secondary-6 font-14">
                  Descripción:
                </div>
                <div class="color-black font-16">
                  {{ item.description | empty }}
                </div>
              </b-col>
              <b-col cols="12" md class="mt-4 mt-md-0">
                <div class="color-secondary-6 font-14">
                  Nombre del Maestro:
                </div>
                <div class="color-black font-16">
                  {{ item.teacher?.name | empty }}
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md class="mt-4 mt-md-3">
                <div class="color-secondary-6 font-14">
                  Especialidad de Salón:
                </div>
                <div class="color-black font-16">
                  {{ item.salonSpecialty?.title | empty }}
                </div>
              </b-col>
              <b-col cols="12" md class="mt-4 mt-md-3">
                <div class="color-secondary-6 font-14">
                  Cupos de Estudiantes:
                </div>
                <div class="color-black font-16">
                  {{ item.studentCapacity | empty }}
                </div>
              </b-col>
              <b-col cols="12" md class="mt-4 mt-md-3">
                <div class="color-secondary-6 font-14">
                  Total de Estudiantes:
                </div>
                <div class="color-black font-16">
                  {{ item.numberOfStudents || 0 }}
                </div>
              </b-col>
              <b-col v-if="item.id" cols="12" md class="pl-4 mt-4 mt-md-3">
                <h4 class="m-0">
                  <b-badge
                    pill
                    :variant="item.active ? 'success' : 'secondary'"
                    :style="
                      !item.active ? { 'background-color': '#868e96' } : {}
                    "
                  >
                    {{ item.active ? 'Activo' : 'Inactivo' }}
                  </b-badge>
                </h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                v-if="item.grades && item.grades.length"
                cols="12"
                md="3"
                class="mt-4 mt-md-3"
              >
                <div class="color-secondary-6 font-14">
                  Grados:
                </div>
                <div class="color-black font-16 d-flex text-green">
                  {{ item.grades.map((x) => x.name).join(', ') | empty }}
                </div>
              </b-col>
              <b-col
                v-if="[true, false].includes(item.determination?.hasHipaa)"
                cols="12"
                md="3"
                class="mt-4 mt-md-3 d-flex align-items-center "
              >
                <badge
                  v-if="[true, false].includes(item.determination.hasHipaa)"
                  :value="item.determination.hasHipaa"
                  :text="
                    item.determination.hasHipaa
                      ? 'Certificado por HIPAA'
                      : ' No Certificado por HIPAA'
                  "
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col
            v-if="!readonly && !editting"
            xs="12"
            md="1"
            class="d-flex align-items-center justify-content-end"
          >
            <MenuDropDown responsive title="Acciones" :items="actions" />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col
      v-if="($slots['default'] || $scopedSlots['default']) && editting"
      class="mt-1"
    >
      <b-card border-variant="none" no-body class="p-2 bg-gray">
        <slot />
      </b-card>
    </b-col>
    <b-col v-if="item.updatedQuota" cols="12">
      <div
        class="rb-alert rounded-bottom pr-2 px-md-3 d-flex align-items-center alert-pending"
      >
        <i class="fas fa-bell-exclamation font-24 mx-3 ml-lg-2"></i>

        <p class="font-weight-normal my-auto font-14">
          El cupo de estudiantes ha sido modificado debido a la siguiente razón
          [{{ item.updatedQuotaReason }}]
        </p>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import CustomInputDisplay from 'CustomInputDisplay';
import MenuDropDown from 'dropdown';
import tapAlternativeLocationCategories from '@/utils/constants/tapAlternativeLocation/tapAlternativeLocationCategories.js';
import Badge from '@/components/common/Badge';

export default {
  name: 'LocationAlternativesAlternativeListItem',
  components: { CustomInputDisplay, MenuDropDown, Badge },
  props: {
    item: { type: Object, required: true, default: null },
    readonly: { type: Boolean, default: false },
    editting: { type: Boolean, default: false },
  },
  computed: {
    actions() {
      return [
        {
          name: 'Editar',
          icon: 'fas fa-edit fa-fw text-green',
          border: 'bottom',
          click: () => this.$emit('edit'),
        },
        {
          name: this.item.determination ? 'Ver Determinación' : 'Determinar',
          icon: 'fas fa-flag fa-fw text-green',
          border: 'bottom',
          visible:
            this.item.category?.id ===
            tapAlternativeLocationCategories.TherapyRoom,
          click: () => {
            this.item.showDeterminate = true;
            this.$emit('edit');
          },
        },
        {
          name: 'Crear Plan de Acción',
          icon: 'fas fa-file-plus fa-fw text-green',
          border: 'bottom',
          visible: this.$store.getters.HasPermission(
            'academic.pei.alternativelocationcatalog.actionplan.create'
          ),
          click: () => this.$emit('create-action-plan'),
        },
        {
          name: 'Editar Cupo',
          icon: 'fas fa-users fa-fw text-green',
          border: 'bottom',
          click: () => {
            this.item.showChangeCapacity = true;
            this.$emit('edit');
          },
        },
        {
          name: 'Eliminar',
          icon: 'fas fa-times-circle fa-fw text-red',
          click: () => this.$emit('remove'),
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.rb-alert {
  top: 97%;
  left: 0;
  width: 100%;
  padding: 10px 0;
}

.alert-pending {
  background-color: #fff5e8;

  & p,
  i {
    color: #af6708;
  }
}

.mb-4rem {
  margin-bottom: 4rem !important;
}

.info-text-title {
  color: map.get($colors, 'gray-6');
  font-size: 1rem;
  font-weight: normal;
}

.info-text {
  color: map.get($colors, 'black');
  font-weight: normal;
  font-size: 1rem;
  size: 1rem;
}

.has-hipaa > span,
.no-has-hipaa > span {
  font-size: 10px;
  margin-bottom: 2px;
}

.has-hipaa > span > i:last-child,
.no-has-hipaa > span > i:last-child {
  color: white;
}

.has-hipaa {
  background-color: #19bbef;
  color: white;
}
.has-hipaa > span > i:first-child {
  color: #73d7f9;
}
.no-has-hipaa {
  background-color: #c9545e;
  color: white;
}
.no-has-hipaa > span > i:first-child {
  color: #d4888c;
}
</style>
